// src/helpers/rutaOrdenesCobro.js
import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || "";
  if (token) config.headers.token = token;
  return config;
});

const parseError = (error) =>
  error?.response?.data?.msg ||
  error?.response?.data?.err ||
  error?.response?.data?.error ||
  error?.message ||
  "Error desconocido";

/** 
 * Sanitiza SOLO medios: remueve la key `tipo` en cada medio.
 * NO toca retenciones (retenciones[].tipo es requerido por el back).
 */
const stripTipoDeep = (obj) => {
  const clone = JSON.parse(JSON.stringify(obj));
  if (Array.isArray(clone.medios)) {
    clone.medios = clone.medios.map(({ tipo, ...rest }) => rest);
  }
  return clone;
};

/* ====== CREATE ====== */
export const postOrdenCobro = async (payload) => {
  try {
    const sanitized = stripTipoDeep(payload);
    console.log("[POST /ordencobro] payload (HELPER) >>>", JSON.stringify(sanitized, null, 2));

    const { data } = await api.post("/ordencobro", sanitized, {
      headers: { "Content-Type": "application/json" },
    });

    return data; // { ok, ordenCobro }
  } catch (error) {
    const err = { ok: false, error: parseError(error) };
    console.error("[POST /ordencobro] ERROR:", err);
    return err;
  }
};

/* ====== READ BY ID ====== */
export const getOrdenCobroById = async (id) => {
  try {
    const { data } = await api.get(`/ordencobro/${id}`);
    return data; // { ok, ordenCobro }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};
export { getOrdenCobroById as getOrdenCobro };

/* ====== READ BY NRO ====== */
export const getOrdenCobroByNro = async (nro, clienteId) => {
  try {
    const { data } = await api.get(`/ordencobro/por-nro/${encodeURIComponent(nro)}`, {
      params: clienteId ? { cliente: clienteId } : undefined,
    });
    return data; // { ok, ordenCobro }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

/* ====== LIST ====== */
export const listOrdenesCobro = async (params) => {
  try {
    const { data } = await api.get("/ordencobro", { params });
    return data; // { ok, ordenes, cantidad }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};

/* ====== CANCEL/VOID ====== */
export const anularOrdenCobro = async (id) => {
  try {
    const { data } = await api.put(`/ordencobro/${id}/anular`);
    return data; // { ok, ordenCobro }
  } catch (error) {
    return { ok: false, error: parseError(error) };
  }
};
